<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="RDAUNSRefs" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :chackbox="false" ref="btngroup" :show="showorhide" @showclick="showclick"
						@hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>

			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<RDAUNStable @StockExport="StockExport" @onRowClick="onRowClick" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></RDAUNStable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import RDAUNStable from './components/RDAUNStable.vue'
	import utils from '../../../common/utils'
	import {
		WMSReportTransceiversSummaryList,
		InventoryClassList,
		WMSReportTransceiversSummaryExport
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			RDAUNStable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '130px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: '日期区间',
						fontSize: '14px',
						color: '#333333',
						placeholder: '',
						types: 'text',
						inputtype: 'date',
						width: '260px',
						lablewith: '125px'
					},
				],
				fromdatalist: [],
				from: {
					date1: "",
					date2: "",
					createOrgName: "",
					InvClass: "",
					Inventory: "",
					batch: "",
				},
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		computed: {
			Currentmonth() {
				let date = new Date()
				let Currentmonth = `${date.getFullYear()}-${date.getMonth() + 1}-1` //获取本月第一天
				return Currentmonth
			},
			Currentday() {
				let date = new Date()
				let Currentday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` //获取当前日期
				return Currentday
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			//this.wMSReportTransceiversSummaryList()
			this.inventoryClassList()
			this.days()

		},
		methods: {
			//默认日期
			days() {
				this.$refs.RDAUNSRefs[4].startTime = this.Currentmonth;
				this.$refs.RDAUNSRefs[4].endTime = this.Currentday;
			},

			// 列表
			async wMSReportTransceiversSummaryList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await WMSReportTransceiversSummaryList({
					date1: this.from.date1 ? this.from.date1 : '',
					date2: this.from.date2 ? this.from.date2 : '',
					createOrgName: this.from.createOrgName,
					InvClass: this.from.InvClass,
					Inventory: this.from.Inventory,
					batch: this.from.batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				// //console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				} else {
					this.$message({
						type: "error",
						message: message
					})
					loading.close();
				}

			},
			async wMSReportTransceiversSummaryExport() {
				let resexprot = await WMSReportTransceiversSummaryExport({
					date1: this.from.date1 ? this.from.date1 : '',
					date2: this.from.date2 ? this.from.date2 : '',
					createOrgName: this.from.createOrgName,
					InvClass: this.from.InvClass,
					Inventory: this.from.Inventory,
					batch: this.from.batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `收发存汇总表${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			StockExport() {
				this.wMSReportTransceiversSummaryExport()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[1].options.push(obj)
					})
				}
			},
			reset() {
				this.$refs.RDAUNSRefs.map((item, index) => {
					if (index == 4) {
						item.startTime = ''
						item.endTime = ''
					}
					item.modelvalue = ''
				})
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			select() {
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata)
				}
				this.pageindex = 1
				try {
					this.from.date1 = this.$refs.RDAUNSRefs[4].startTime
					this.from.date2 = this.$refs.RDAUNSRefs[4].endTime
					this.from.createOrgName = this.$refs.RDAUNSRefs[0].modelvalue
					this.from.InvClass = this.$refs.RDAUNSRefs[1].modelvalue
					this.from.Inventory = this.$refs.RDAUNSRefs[2].modelvalue
					this.from.batch = this.$refs.RDAUNSRefs[3].modelvalue
					this.wMSReportTransceiversSummaryList()
				} catch (error) {
					this.from.createOrgName = this.$refs.RDAUNSRefs[0].modelvalue
					this.from.InvClass = this.$refs.RDAUNSRefs[1].modelvalue
					this.wMSReportTransceiversSummaryList()
				}

			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			onRowClick(val) {
				//console.log(val, 'val');
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wMSReportTransceiversSummaryList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wMSReportTransceiversSummaryList()
			},
		},
		watch: {
			showorhide(newVal) {
				if (newVal == true) {
					//  this.$refs.RDAUNSRefs[4].startTime = "2012-12-5"
					//this.days()
					// //console.log(newVal,'newVal');
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}


	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 50px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 30px;
	}
</style>
